import { OverlayContainer, StyledNotification, StyledSpinner } from './Spinner.styles';
import { useTranslation } from 'react-i18next';

const Spinner = (props: {
  className?: string;
  hideSpinner?: boolean;
  contained?: boolean;
  size?: number;
}) => {
  const [t] = useTranslation();
  return (
    <OverlayContainer {...props} contained={props.contained}>
      {props.hideSpinner ? (
        <StyledNotification data-testid="detectLoader">{t('Detecting the fields')}</StyledNotification>
      ) : (
        <StyledSpinner data-testid="loaderSpinner" size={props.size} />
      )}
    </OverlayContainer>
  );
};

export default Spinner;
